export type S3UploadOptions = {
  bucket: string;
  acl: string;
  awsaccesskeyid: string;
  expires: string;
  key: string;
  policy: string;
  signature: string;
  success_action_status: string;
  'Content-Type': string;
};

class S3UploadError extends Error {
  detail: string;
  status: number;

  constructor({ detail, status }: { detail: string; status: number }, ...params: any) {
    super(...params);

    this.name = 'S3UploadError';
    this.detail = detail;
    this.status = status;
  }
}

export async function uploadToS3(
  file: File,
  json: S3UploadOptions,
  opts: { processData?: (data: FormData) => void } = {},
) {
  let data = new FormData();

  Object.keys(json || {}).forEach((key: keyof S3UploadOptions) => {
    data.append(key, json[key]);
  });

  if (opts.processData) {
    opts.processData(data);
  }
  data.append('file', file);

  let parser = new DOMParser();
  let url = `https://s3.amazonaws.com/${json.bucket}`;

  let response = await window.fetch(url, {
    method: 'POST',
    body: data,
  });

  let text = await response.text();
  let xml = parser.parseFromString(text, 'text/xml');

  if (response.ok) {
    return { key: xml.getElementsByTagName('Location')[0].textContent ?? '' };
  } else {
    let detail =
      xml?.getElementsByTagName('Message')?.[0]?.textContent ?? 'Something went wrong while uploading to AWS S3.';
    throw new S3UploadError(
      {
        detail,
        status: response.status,
      },
      text,
    );
  }
}
